import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ItemTypeFieldsApi } from '@/lib/api/common/itemTypeFields';
import type { CustomField } from '@/lib/api/types/customField';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const itemTypeFieldsQueryOptions = (itemTypeId: number) => {
  return queryOptions<CustomField[]>({
    queryKey: commonQueryKeys.itemTypes.fields(itemTypeId),
    queryFn: () => ItemTypeFieldsApi.getFieldsForItemType(itemTypeId),
    enabled: !!itemTypeId,
  });
};

export const useItemTypeFieldsQuery = (
  itemTypeId: number,
  options: Partial<UseQueryOptions<CustomField[]>> = {},
) => {
  return useQuery({
    ...itemTypeFieldsQueryOptions(itemTypeId),
    ...options,
  });
};
